
<!-- group column header tooltip -->
<div class="custom-tooltip header no-fade-out" *ngIf="isHeader && parentGroupLevel < maxLevel" [ngClass]="{'fade-in': !show}"
    (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
    <div [hidden]="selectedParents" style="width: 60px; height: 30px; margin-top: -10px;">
        <cv-loader size="small" [overlay]="false"></cv-loader>
    </div>
    <p *ngFor="let each of selectedParents">{{each}}</p>
</div>
<!-- group column cell tooltip -->
<div class="custom-tooltip cell no-fade-out" *ngIf="!isHeader" [ngClass]="{'fade-in': !show}"
    (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
    <p>{{params.value}}</p>
</div>
